import { lazy } from 'react';

const iconsMap = {
  IconArrowCircleDownFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowCircleDownFilled').then(module => ({
      default: module.IconArrowCircleDownFilled,
    })),
  ),
  IconArrowCircleLeftFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowCircleLeftFilled').then(module => ({
      default: module.IconArrowCircleLeftFilled,
    })),
  ),
  IconArrowCircleRightFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowCircleRightFilled').then(module => ({
      default: module.IconArrowCircleRightFilled,
    })),
  ),
  IconArrowCircleUpFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowCircleUpFilled').then(module => ({
      default: module.IconArrowCircleUpFilled,
    })),
  ),
  IconArrowDownFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowDownFilled').then(module => ({
      default: module.IconArrowDownFilled,
    })),
  ),
  IconArrowLeftFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowLeftFilled').then(module => ({
      default: module.IconArrowLeftFilled,
    })),
  ),
  IconArrowRightFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowRightFilled').then(module => ({
      default: module.IconArrowRightFilled,
    })),
  ),
  IconArrowUpFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowUpFilled').then(module => ({
      default: module.IconArrowUpFilled,
    })),
  ),
  IconArrowDownLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowDownLarge').then(module => ({
      default: module.IconArrowDownLarge,
    })),
  ),
  IconArrowLeftLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowLeftLarge').then(module => ({
      default: module.IconArrowLeftLarge,
    })),
  ),
  IconArrowRightLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowRightLarge').then(module => ({
      default: module.IconArrowRightLarge,
    })),
  ),
  IconArrowUpLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowUpLarge').then(module => ({
      default: module.IconArrowUpLarge,
    })),
  ),
  IconArrowDownOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowDownOutline').then(module => ({
      default: module.IconArrowDownOutline,
    })),
  ),
  IconArrowLeftOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowLeftOutline').then(module => ({
      default: module.IconArrowLeftOutline,
    })),
  ),
  IconArrowRightOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowRightOutline').then(module => ({
      default: module.IconArrowRightOutline,
    })),
  ),
  IconArrowUpOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowUpOutline').then(module => ({
      default: module.IconArrowUpOutline,
    })),
  ),
  IconArrowDownSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowDownSmall').then(module => ({
      default: module.IconArrowDownSmall,
    })),
  ),
  IconArrowLeftSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowLeftSmall').then(module => ({
      default: module.IconArrowLeftSmall,
    })),
  ),
  IconArrowRightSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowRightSmall').then(module => ({
      default: module.IconArrowRightSmall,
    })),
  ),
  IconArrowUpSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowUpSmall').then(module => ({
      default: module.IconArrowUpSmall,
    })),
  ),
  IconCheckboxOff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCheckboxOff').then(module => ({
      default: module.IconCheckboxOff,
    })),
  ),
  IconCheckboxOn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCheckboxOn').then(module => ({
      default: module.IconCheckboxOn,
    })),
  ),
  IconChevronCircleDownFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronCircleDownFilled').then(module => ({
      default: module.IconChevronCircleDownFilled,
    })),
  ),
  IconChevronCircleLeftFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronCircleLeftFilled').then(module => ({
      default: module.IconChevronCircleLeftFilled,
    })),
  ),
  IconChevronCircleRightFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronCircleRightFilled').then(module => ({
      default: module.IconChevronCircleRightFilled,
    })),
  ),
  IconChevronCircleUpFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronCircleUpFilled').then(module => ({
      default: module.IconChevronCircleUpFilled,
    })),
  ),
  IconChevronDownLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronDownLarge').then(module => ({
      default: module.IconChevronDownLarge,
    })),
  ),
  IconChevronLeftLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronLeftLarge').then(module => ({
      default: module.IconChevronLeftLarge,
    })),
  ),
  IconChevronRightLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronRightLarge').then(module => ({
      default: module.IconChevronRightLarge,
    })),
  ),
  IconChevronUpLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronUpLarge').then(module => ({
      default: module.IconChevronUpLarge,
    })),
  ),
  IconChevronDownOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronDownOutline').then(module => ({
      default: module.IconChevronDownOutline,
    })),
  ),
  IconChevronLeftOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronLeftOutline').then(module => ({
      default: module.IconChevronLeftOutline,
    })),
  ),
  IconChevronRightOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronRightOutline').then(module => ({
      default: module.IconChevronRightOutline,
    })),
  ),
  IconChevronUpOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronUpOutline').then(module => ({
      default: module.IconChevronUpOutline,
    })),
  ),
  IconChevronDownSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronDownSmall').then(module => ({
      default: module.IconChevronDownSmall,
    })),
  ),
  IconChevronLeftSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronLeftSmall').then(module => ({
      default: module.IconChevronLeftSmall,
    })),
  ),
  IconChevronRightSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronRightSmall').then(module => ({
      default: module.IconChevronRightSmall,
    })),
  ),
  IconChevronUpSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChevronUpSmall').then(module => ({
      default: module.IconChevronUpSmall,
    })),
  ),
  IconRemoveVideo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRemoveVideo').then(module => ({
      default: module.IconRemoveVideo,
    })),
  ),
  IconCrossLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrossLarge').then(module => ({
      default: module.IconCrossLarge,
    })),
  ),
  IconCrossCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrossCircleFilled').then(module => ({
      default: module.IconCrossCircleFilled,
    })),
  ),
  IconCrossCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrossCircleOutline').then(module => ({
      default: module.IconCrossCircleOutline,
    })),
  ),
  IconCrossSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrossSmall').then(module => ({
      default: module.IconCrossSmall,
    })),
  ),
  IconFitIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFitIn').then(module => ({
      default: module.IconFitIn,
    })),
  ),
  IconFitOut: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFitOut').then(module => ({
      default: module.IconFitOut,
    })),
  ),
  IconFold: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFold').then(module => ({
      default: module.IconFold,
    })),
  ),
  IconFrameCollapse: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFrameCollapse').then(module => ({
      default: module.IconFrameCollapse,
    })),
  ),
  IconFrameExpand: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFrameExpand').then(module => ({
      default: module.IconFrameExpand,
    })),
  ),
  IconLockLargeFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLockLargeFilled').then(module => ({
      default: module.IconLockLargeFilled,
    })),
  ),
  IconUnlockLargeFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnlockLargeFilled').then(module => ({
      default: module.IconUnlockLargeFilled,
    })),
  ),
  IconLockLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLockLarge').then(module => ({
      default: module.IconLockLarge,
    })),
  ),
  IconUnlockLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnlockLarge').then(module => ({
      default: module.IconUnlockLarge,
    })),
  ),
  IconLockSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLockSmall').then(module => ({
      default: module.IconLockSmall,
    })),
  ),
  IconUnlockSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnlockSmall').then(module => ({
      default: module.IconUnlockSmall,
    })),
  ),
  IconMinusCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMinusCircleFilled').then(module => ({
      default: module.IconMinusCircleFilled,
    })),
  ),
  IconMinusCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMinusCircleOutline').then(module => ({
      default: module.IconMinusCircleOutline,
    })),
  ),
  IconMinusLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMinusLarge').then(module => ({
      default: module.IconMinusLarge,
    })),
  ),
  IconMinusSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMinusSmall').then(module => ({
      default: module.IconMinusSmall,
    })),
  ),
  IconPlusCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlusCircleFilled').then(module => ({
      default: module.IconPlusCircleFilled,
    })),
  ),
  IconPlusCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlusCircleOutline').then(module => ({
      default: module.IconPlusCircleOutline,
    })),
  ),
  IconPlusLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlusLarge').then(module => ({
      default: module.IconPlusLarge,
    })),
  ),
  IconPlusSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlusSmall').then(module => ({
      default: module.IconPlusSmall,
    })),
  ),
  IconPosition: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPosition').then(module => ({
      default: module.IconPosition,
    })),
  ),
  IconUnfold: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnfold').then(module => ({
      default: module.IconUnfold,
    })),
  ),
  IconRadioOff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRadioOff').then(module => ({
      default: module.IconRadioOff,
    })),
  ),
  IconRadioOn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRadioOn').then(module => ({
      default: module.IconRadioOn,
    })),
  ),
  IconTickCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTickCircleFilled').then(module => ({
      default: module.IconTickCircleFilled,
    })),
  ),
  IconTickCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTickCircleOutline').then(module => ({
      default: module.IconTickCircleOutline,
    })),
  ),
  IconTickLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTickLarge').then(module => ({
      default: module.IconTickLarge,
    })),
  ),
  IconTickSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTickSmall').then(module => ({
      default: module.IconTickSmall,
    })),
  ),
  IconABExperiment: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconABExperiment').then(module => ({
      default: module.IconABExperiment,
    })),
  ),
  IconAccounts: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAccounts').then(module => ({
      default: module.IconAccounts,
    })),
  ),
  IconLeftRightCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLeftRightCircleOutline').then(module => ({
      default: module.IconLeftRightCircleOutline,
    })),
  ),
  IconAssignmentTurnedIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAssignmentTurnedIn').then(module => ({
      default: module.IconAssignmentTurnedIn,
    })),
  ),
  IconAttach: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAttach').then(module => ({
      default: module.IconAttach,
    })),
  ),
  IconAttributes: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAttributes').then(module => ({
      default: module.IconAttributes,
    })),
  ),
  IconAnimation: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnimation').then(module => ({
      default: module.IconAnimation,
    })),
  ),
  IconFunnel: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFunnel').then(module => ({
      default: module.IconFunnel,
    })),
  ),
  IconMetrics: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMetrics').then(module => ({
      default: module.IconMetrics,
    })),
  ),
  IconBookmarkFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBookmarkFilled').then(module => ({
      default: module.IconBookmarkFilled,
    })),
  ),
  IconBookmarkOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBookmarkOutline').then(module => ({
      default: module.IconBookmarkOutline,
    })),
  ),
  IconChallengesFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChallengesFilled').then(module => ({
      default: module.IconChallengesFilled,
    })),
  ),
  IconChallengesOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChallengesOutline').then(module => ({
      default: module.IconChallengesOutline,
    })),
  ),
  IconClock: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconClock').then(module => ({
      default: module.IconClock,
    })),
  ),
  IconCloudAutoSave: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCloudAutoSave').then(module => ({
      default: module.IconCloudAutoSave,
    })),
  ),
  IconCloudInfo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCloudInfo').then(module => ({
      default: module.IconCloudInfo,
    })),
  ),
  IconCloudNotSaved: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCloudNotSaved').then(module => ({
      default: module.IconCloudNotSaved,
    })),
  ),
  IconCloudOffline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCloudOffline').then(module => ({
      default: module.IconCloudOffline,
    })),
  ),
  IconCloudUpload: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCloudUpload').then(module => ({
      default: module.IconCloudUpload,
    })),
  ),
  IconComment: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconComment').then(module => ({
      default: module.IconComment,
    })),
  ),
  IconCreditCard: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCreditCard').then(module => ({
      default: module.IconCreditCard,
    })),
  ),
  IconDashboard: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDashboard').then(module => ({
      default: module.IconDashboard,
    })),
  ),
  IconDebugger: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDebugger').then(module => ({
      default: module.IconDebugger,
    })),
  ),
  IconDelete: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDelete').then(module => ({
      default: module.IconDelete,
    })),
  ),
  IconDiscoverFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDiscoverFilled').then(module => ({
      default: module.IconDiscoverFilled,
    })),
  ),
  IconDiscoverOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDiscoverOutline').then(module => ({
      default: module.IconDiscoverOutline,
    })),
  ),
  IconDownload: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDownload').then(module => ({
      default: module.IconDownload,
    })),
  ),
  IconUpload: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUpload').then(module => ({
      default: module.IconUpload,
    })),
  ),
  IconEdit: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEdit').then(module => ({
      default: module.IconEdit,
    })),
  ),
  IconEmail: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmail').then(module => ({
      default: module.IconEmail,
    })),
  ),
  IconEmbedCode: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmbedCode').then(module => ({
      default: module.IconEmbedCode,
    })),
  ),
  IconEvents: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEvents').then(module => ({
      default: module.IconEvents,
    })),
  ),
  IconFilter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFilter').then(module => ({
      default: module.IconFilter,
    })),
  ),
  IconFingerprint: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFingerprint').then(module => ({
      default: module.IconFingerprint,
    })),
  ),
  IconFlag: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlag').then(module => ({
      default: module.IconFlag,
    })),
  ),
  IconCrownCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrownCircleFilled').then(module => ({
      default: module.IconCrownCircleFilled,
    })),
  ),
  IconCrownFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrownFilled').then(module => ({
      default: module.IconCrownFilled,
    })),
  ),
  IconCrownOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrownOutline').then(module => ({
      default: module.IconCrownOutline,
    })),
  ),
  IconHeartFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHeartFilled').then(module => ({
      default: module.IconHeartFilled,
    })),
  ),
  IconHeartOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHeartOutline').then(module => ({
      default: module.IconHeartOutline,
    })),
  ),
  IconHelpChat: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHelpChat').then(module => ({
      default: module.IconHelpChat,
    })),
  ),
  IconHomeFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHomeFilled').then(module => ({
      default: module.IconHomeFilled,
    })),
  ),
  IconHomeOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHomeOutline').then(module => ({
      default: module.IconHomeOutline,
    })),
  ),
  IconEyeHidden: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyeHidden').then(module => ({
      default: module.IconEyeHidden,
    })),
  ),
  IconEyeShown: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyeShown').then(module => ({
      default: module.IconEyeShown,
    })),
  ),
  IconInfoCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInfoCircleOutline').then(module => ({
      default: module.IconInfoCircleOutline,
    })),
  ),
  IconLandscape: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLandscape').then(module => ({
      default: module.IconLandscape,
    })),
  ),
  IconPortrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPortrait').then(module => ({
      default: module.IconPortrait,
    })),
  ),
  IconSquare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSquare').then(module => ({
      default: module.IconSquare,
    })),
  ),
  IconLeaderboards: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLeaderboards').then(module => ({
      default: module.IconLeaderboards,
    })),
  ),
  IconLink: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLink').then(module => ({
      default: module.IconLink,
    })),
  ),
  IconLoading: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLoading').then(module => ({
      default: module.IconLoading,
    })),
  ),
  IconLocked: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLocked').then(module => ({
      default: module.IconLocked,
    })),
  ),
  IconUnlocked: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnlocked').then(module => ({
      default: module.IconUnlocked,
    })),
  ),
  IconLogout: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLogout').then(module => ({
      default: module.IconLogout,
    })),
  ),
  IconMenu: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMenu').then(module => ({
      default: module.IconMenu,
    })),
  ),
  IconMessage: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMessage').then(module => ({
      default: module.IconMessage,
    })),
  ),
  IconMonitoring: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMonitoring').then(module => ({
      default: module.IconMonitoring,
    })),
  ),
  IconMore: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMore').then(module => ({
      default: module.IconMore,
    })),
  ),
  IconNavigation: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNavigation').then(module => ({
      default: module.IconNavigation,
    })),
  ),
  IconNewWindow: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNewWindow').then(module => ({
      default: module.IconNewWindow,
    })),
  ),
  IconSpeakerNoAds: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpeakerNoAds').then(module => ({
      default: module.IconSpeakerNoAds,
    })),
  ),
  IconNoAds: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoAds').then(module => ({
      default: module.IconNoAds,
    })),
  ),
  IconNotification: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNotification').then(module => ({
      default: module.IconNotification,
    })),
  ),
  IconOverview: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconOverview').then(module => ({
      default: module.IconOverview,
    })),
  ),
  IconProfileAdd: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconProfileAdd').then(module => ({
      default: module.IconProfileAdd,
    })),
  ),
  IconProfileFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconProfileFilled').then(module => ({
      default: module.IconProfileFilled,
    })),
  ),
  IconProfileOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconProfileOutline').then(module => ({
      default: module.IconProfileOutline,
    })),
  ),
  IconProfileReport: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconProfileReport').then(module => ({
      default: module.IconProfileReport,
    })),
  ),
  IconQuestionCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQuestionCircleOutline').then(module => ({
      default: module.IconQuestionCircleOutline,
    })),
  ),
  IconQuestionCircle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQuestionCircle').then(module => ({
      default: module.IconQuestionCircle,
    })),
  ),
  IconQuestion: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQuestion').then(module => ({
      default: module.IconQuestion,
    })),
  ),
  IconQuote: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQuote').then(module => ({
      default: module.IconQuote,
    })),
  ),
  IconRecent: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRecent').then(module => ({
      default: module.IconRecent,
    })),
  ),
  IconReduce: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReduce').then(module => ({
      default: module.IconReduce,
    })),
  ),
  IconRefresh: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRefresh').then(module => ({
      default: module.IconRefresh,
    })),
  ),
  IconReplay: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReplay').then(module => ({
      default: module.IconReplay,
    })),
  ),
  IconRocket: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRocket').then(module => ({
      default: module.IconRocket,
    })),
  ),
  IconRadioWaves: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRadioWaves').then(module => ({
      default: module.IconRadioWaves,
    })),
  ),
  IconCompanySymbol: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCompanySymbol').then(module => ({
      default: module.IconCompanySymbol,
    })),
  ),
  IconSearch: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSearch').then(module => ({
      default: module.IconSearch,
    })),
  ),
  IconSegments: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSegments').then(module => ({
      default: module.IconSegments,
    })),
  ),
  IconSend: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSend').then(module => ({
      default: module.IconSend,
    })),
  ),
  IconSettings: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSettings').then(module => ({
      default: module.IconSettings,
    })),
  ),
  IconArrowShare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowShare').then(module => ({
      default: module.IconArrowShare,
    })),
  ),
  IconShareUpload: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShareUpload').then(module => ({
      default: module.IconShareUpload,
    })),
  ),
  IconSizeFull: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSizeFull').then(module => ({
      default: module.IconSizeFull,
    })),
  ),
  IconSizeMiddle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSizeMiddle').then(module => ({
      default: module.IconSizeMiddle,
    })),
  ),
  IconSizeSmall: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSizeSmall').then(module => ({
      default: module.IconSizeSmall,
    })),
  ),
  IconStarFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStarFilled').then(module => ({
      default: module.IconStarFilled,
    })),
  ),
  IconStarOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStarOutline').then(module => ({
      default: module.IconStarOutline,
    })),
  ),
  IconStarSemiFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStarSemiFilled').then(module => ({
      default: module.IconStarSemiFilled,
    })),
  ),
  IconSupport: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSupport').then(module => ({
      default: module.IconSupport,
    })),
  ),
  IconBookmark: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBookmark').then(module => ({
      default: module.IconBookmark,
    })),
  ),
  IconShieldVerified: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShieldVerified').then(module => ({
      default: module.IconShieldVerified,
    })),
  ),
  IconWallet: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWallet').then(module => ({
      default: module.IconWallet,
    })),
  ),
  IconWatermark: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWatermark').then(module => ({
      default: module.IconWatermark,
    })),
  ),
  IconWarningTriangleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWarningTriangleOutline').then(module => ({
      default: module.IconWarningTriangleOutline,
    })),
  ),
  IconWarningCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWarningCircleOutline').then(module => ({
      default: module.IconWarningCircleOutline,
    })),
  ),
  IconWiFi: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWiFi').then(module => ({
      default: module.IconWiFi,
    })),
  ),
  IconZoomIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconZoomIn').then(module => ({
      default: module.IconZoomIn,
    })),
  ),
  IconZoomOut: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconZoomOut').then(module => ({
      default: module.IconZoomOut,
    })),
  ),
  IconBurger: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBurger').then(module => ({
      default: module.IconBurger,
    })),
  ),
  IconMeme: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMeme').then(module => ({
      default: module.IconMeme,
    })),
  ),
  IconLetter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLetter').then(module => ({
      default: module.IconLetter,
    })),
  ),
  IconLabels: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLabels').then(module => ({
      default: module.IconLabels,
    })),
  ),
  IconDetails: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDetails').then(module => ({
      default: module.IconDetails,
    })),
  ),
  IconGeoBlocking: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGeoBlocking').then(module => ({
      default: module.IconGeoBlocking,
    })),
  ),
  IconHiddenFromChina: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHiddenFromChina').then(module => ({
      default: module.IconHiddenFromChina,
    })),
  ),
  IconList: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconList').then(module => ({
      default: module.IconList,
    })),
  ),
  IconMature: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMature').then(module => ({
      default: module.IconMature,
    })),
  ),
  IconNoCommercial: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoCommercial').then(module => ({
      default: module.IconNoCommercial,
    })),
  ),
  IconPartnership: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPartnership').then(module => ({
      default: module.IconPartnership,
    })),
  ),
  IconProfileBlackList: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconProfileBlackList').then(module => ({
      default: module.IconProfileBlackList,
    })),
  ),
  IconSexuallySuggestive: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSexuallySuggestive').then(module => ({
      default: module.IconSexuallySuggestive,
    })),
  ),
  IconVariant: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVariant').then(module => ({
      default: module.IconVariant,
    })),
  ),
  IconAddPage: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAddPage').then(module => ({
      default: module.IconAddPage,
    })),
  ),
  IconAddPhoto: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAddPhoto').then(module => ({
      default: module.IconAddPhoto,
    })),
  ),
  IconAddSquareFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAddSquareFilled').then(module => ({
      default: module.IconAddSquareFilled,
    })),
  ),
  IconAddVideo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAddVideo').then(module => ({
      default: module.IconAddVideo,
    })),
  ),
  IconAdjust: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAdjust').then(module => ({
      default: module.IconAdjust,
    })),
  ),
  IconAIMusic: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAIMusic').then(module => ({
      default: module.IconAIMusic,
    })),
  ),
  IconAITools: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAITools').then(module => ({
      default: module.IconAITools,
    })),
  ),
  IconAlignCenter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignCenter').then(module => ({
      default: module.IconAlignCenter,
    })),
  ),
  IconAlignCenterBottom: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignCenterBottom').then(module => ({
      default: module.IconAlignCenterBottom,
    })),
  ),
  IconAlignCenterCenter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignCenterCenter').then(module => ({
      default: module.IconAlignCenterCenter,
    })),
  ),
  IconAlignCenterTop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignCenterTop').then(module => ({
      default: module.IconAlignCenterTop,
    })),
  ),
  IconAlignLeftBottom: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignLeftBottom').then(module => ({
      default: module.IconAlignLeftBottom,
    })),
  ),
  IconAlignLeftCenter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignLeftCenter').then(module => ({
      default: module.IconAlignLeftCenter,
    })),
  ),
  IconAlignLeftTop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignLeftTop').then(module => ({
      default: module.IconAlignLeftTop,
    })),
  ),
  IconAlignRightBottom: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignRightBottom').then(module => ({
      default: module.IconAlignRightBottom,
    })),
  ),
  IconAlignRightCenter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignRightCenter').then(module => ({
      default: module.IconAlignRightCenter,
    })),
  ),
  IconAlignRightTop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignRightTop').then(module => ({
      default: module.IconAlignRightTop,
    })),
  ),
  IconAlignLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignLeft').then(module => ({
      default: module.IconAlignLeft,
    })),
  ),
  IconAlignRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignRight').then(module => ({
      default: module.IconAlignRight,
    })),
  ),
  IconAnchorPointsCorner: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnchorPointsCorner').then(module => ({
      default: module.IconAnchorPointsCorner,
    })),
  ),
  IconAnchorPointsSmooth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnchorPointsSmooth').then(module => ({
      default: module.IconAnchorPointsSmooth,
    })),
  ),
  IconAnimationIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnimationIn').then(module => ({
      default: module.IconAnimationIn,
    })),
  ),
  IconAnimationOut: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnimationOut').then(module => ({
      default: module.IconAnimationOut,
    })),
  ),
  IconApplyAll: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconApplyAll').then(module => ({
      default: module.IconApplyAll,
    })),
  ),
  IconApply: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconApply').then(module => ({
      default: module.IconApply,
    })),
  ),
  IconArtisticBrushes: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArtisticBrushes').then(module => ({
      default: module.IconArtisticBrushes,
    })),
  ),
  IconAudioEffects: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAudioEffects').then(module => ({
      default: module.IconAudioEffects,
    })),
  ),
  IconAuto: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAuto').then(module => ({
      default: module.IconAuto,
    })),
  ),
  IconBackground: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBackground').then(module => ({
      default: module.IconBackground,
    })),
  ),
  IconBatchEditor: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBatchEditor').then(module => ({
      default: module.IconBatchEditor,
    })),
  ),
  IconBeforeAfter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBeforeAfter').then(module => ({
      default: module.IconBeforeAfter,
    })),
  ),
  IconBackgroundRemove: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBackgroundRemove').then(module => ({
      default: module.IconBackgroundRemove,
    })),
  ),
  IconBlackAndWhite: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlackAndWhite').then(module => ({
      default: module.IconBlackAndWhite,
    })),
  ),
  IconBlemishFix: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlemishFix').then(module => ({
      default: module.IconBlemishFix,
    })),
  ),
  IconBlending: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlending').then(module => ({
      default: module.IconBlending,
    })),
  ),
  IconBold: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBold').then(module => ({
      default: module.IconBold,
    })),
  ),
  IconImage: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconImage').then(module => ({
      default: module.IconImage,
    })),
  ),
  IconBoxRectangle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBoxRectangle').then(module => ({
      default: module.IconBoxRectangle,
    })),
  ),
  IconBrightness: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrightness').then(module => ({
      default: module.IconBrightness,
    })),
  ),
  IconBrushLock: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrushLock').then(module => ({
      default: module.IconBrushLock,
    })),
  ),
  IconBrushReverse: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrushReverse').then(module => ({
      default: module.IconBrushReverse,
    })),
  ),
  IconBrush: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrush').then(module => ({
      default: module.IconBrush,
    })),
  ),
  IconBulk: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBulk').then(module => ({
      default: module.IconBulk,
    })),
  ),
  IconBurnFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBurnFilled').then(module => ({
      default: module.IconBurnFilled,
    })),
  ),
  IconBurnOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBurnOutline').then(module => ({
      default: module.IconBurnOutline,
    })),
  ),
  IconCallout: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCallout').then(module => ({
      default: module.IconCallout,
    })),
  ),
  IconCameraFlip: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCameraFlip').then(module => ({
      default: module.IconCameraFlip,
    })),
  ),
  IconCamera: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCamera').then(module => ({
      default: module.IconCamera,
    })),
  ),
  IconCanvasEffect: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCanvasEffect').then(module => ({
      default: module.IconCanvasEffect,
    })),
  ),
  IconCanvas: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCanvas').then(module => ({
      default: module.IconCanvas,
    })),
  ),
  IconCapitalize: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalize').then(module => ({
      default: module.IconCapitalize,
    })),
  ),
  IconClarity: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconClarity').then(module => ({
      default: module.IconClarity,
    })),
  ),
  IconClarityEye: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconClarityEye').then(module => ({
      default: module.IconClarityEye,
    })),
  ),
  IconClear: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconClear').then(module => ({
      default: module.IconClear,
    })),
  ),
  IconTarget: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTarget').then(module => ({
      default: module.IconTarget,
    })),
  ),
  IconClone: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconClone').then(module => ({
      default: module.IconClone,
    })),
  ),
  IconLayoutCollage: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLayoutCollage').then(module => ({
      default: module.IconLayoutCollage,
    })),
  ),
  IconColorExposure: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColorExposure').then(module => ({
      default: module.IconColorExposure,
    })),
  ),
  IconColorPicker: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColorPicker').then(module => ({
      default: module.IconColorPicker,
    })),
  ),
  IconColor: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColor').then(module => ({
      default: module.IconColor,
    })),
  ),
  IconColumns: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColumns').then(module => ({
      default: module.IconColumns,
    })),
  ),
  IconContrast: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconContrast').then(module => ({
      default: module.IconContrast,
    })),
  ),
  IconCopy: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCopy').then(module => ({
      default: module.IconCopy,
    })),
  ),
  IconCornerRadius: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCornerRadius').then(module => ({
      default: module.IconCornerRadius,
    })),
  ),
  IconCrop3x2: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrop3x2').then(module => ({
      default: module.IconCrop3x2,
    })),
  ),
  IconCrop3x4: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrop3x4').then(module => ({
      default: module.IconCrop3x4,
    })),
  ),
  IconCrop16x9: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrop16x9').then(module => ({
      default: module.IconCrop16x9,
    })),
  ),
  IconCropFacebookCover: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropFacebookCover').then(module => ({
      default: module.IconCropFacebookCover,
    })),
  ),
  IconCropFacebookPost: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropFacebookPost').then(module => ({
      default: module.IconCropFacebookPost,
    })),
  ),
  IconCropInstagramStory: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropInstagramStory').then(module => ({
      default: module.IconCropInstagramStory,
    })),
  ),
  IconCropInstagramPortrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropInstagramPortrait').then(module => ({
      default: module.IconCropInstagramPortrait,
    })),
  ),
  IconCropInstagramSquare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropInstagramSquare').then(module => ({
      default: module.IconCropInstagramSquare,
    })),
  ),
  IconCropPinterest: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropPinterest').then(module => ({
      default: module.IconCropPinterest,
    })),
  ),
  IconCropTwitterHeader: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropTwitterHeader').then(module => ({
      default: module.IconCropTwitterHeader,
    })),
  ),
  IconCropTwitterPost: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropTwitterPost').then(module => ({
      default: module.IconCropTwitterPost,
    })),
  ),
  IconCropYouTubeThumbnail: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropYouTubeThumbnail').then(module => ({
      default: module.IconCropYouTubeThumbnail,
    })),
  ),
  IconCrop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCrop').then(module => ({
      default: module.IconCrop,
    })),
  ),
  IconCurves: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCurves').then(module => ({
      default: module.IconCurves,
    })),
  ),
  IconCutout: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCutout').then(module => ({
      default: module.IconCutout,
    })),
  ),
  IconDeBlock: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDeBlock').then(module => ({
      default: module.IconDeBlock,
    })),
  ),
  IconDeNoise: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDeNoise').then(module => ({
      default: module.IconDeNoise,
    })),
  ),
  IconSpeedDecrease: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpeedDecrease').then(module => ({
      default: module.IconSpeedDecrease,
    })),
  ),
  IconSpeedAdjust: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpeedAdjust').then(module => ({
      default: module.IconSpeedAdjust,
    })),
  ),
  IconSpeedIncrease: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpeedIncrease').then(module => ({
      default: module.IconSpeedIncrease,
    })),
  ),
  IconSpeed: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpeed').then(module => ({
      default: module.IconSpeed,
    })),
  ),
  IconDeleteFragment: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDeleteFragment').then(module => ({
      default: module.IconDeleteFragment,
    })),
  ),
  IconBrilliant: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrilliant').then(module => ({
      default: module.IconBrilliant,
    })),
  ),
  IconDiagonalLines: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDiagonalLines').then(module => ({
      default: module.IconDiagonalLines,
    })),
  ),
  IconDispersionDirection: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDispersionDirection').then(module => ({
      default: module.IconDispersionDirection,
    })),
  ),
  IconDispersion: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDispersion').then(module => ({
      default: module.IconDispersion,
    })),
  ),
  IconDottedBrush: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDottedBrush').then(module => ({
      default: module.IconDottedBrush,
    })),
  ),
  IconDoubleExposure: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDoubleExposure').then(module => ({
      default: module.IconDoubleExposure,
    })),
  ),
  IconDuplicate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDuplicate').then(module => ({
      default: module.IconDuplicate,
    })),
  ),
  IconDuration: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDuration').then(module => ({
      default: module.IconDuration,
    })),
  ),
  IconEditClip: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEditClip').then(module => ({
      default: module.IconEditClip,
    })),
  ),
  IconEditPhoto: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEditPhoto').then(module => ({
      default: module.IconEditPhoto,
    })),
  ),
  IconEffects: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEffects').then(module => ({
      default: module.IconEffects,
    })),
  ),
  IconHDPortrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHDPortrait').then(module => ({
      default: module.IconHDPortrait,
    })),
  ),
  IconEraser: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEraser').then(module => ({
      default: module.IconEraser,
    })),
  ),
  IconExportVideo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconExportVideo').then(module => ({
      default: module.IconExportVideo,
    })),
  ),
  IconExtractAudio: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconExtractAudio').then(module => ({
      default: module.IconExtractAudio,
    })),
  ),
  IconEyeBag: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyeBag').then(module => ({
      default: module.IconEyeBag,
    })),
  ),
  IconEyeColor: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyeColor').then(module => ({
      default: module.IconEyeColor,
    })),
  ),
  IconEyebrowsDistance: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyebrowsDistance').then(module => ({
      default: module.IconEyebrowsDistance,
    })),
  ),
  IconEyebrowsHeight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyebrowsHeight').then(module => ({
      default: module.IconEyebrowsHeight,
    })),
  ),
  IconEyebrowsMain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyebrowsMain').then(module => ({
      default: module.IconEyebrowsMain,
    })),
  ),
  IconEyebrowsRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyebrowsRotate').then(module => ({
      default: module.IconEyebrowsRotate,
    })),
  ),
  IconEyebrowsThickness: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyebrowsThickness').then(module => ({
      default: module.IconEyebrowsThickness,
    })),
  ),
  IconEyebrowsUp: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyebrowsUp').then(module => ({
      default: module.IconEyebrowsUp,
    })),
  ),
  IconEyeliner: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyeliner').then(module => ({
      default: module.IconEyeliner,
    })),
  ),
  IconEyesAdd: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesAdd').then(module => ({
      default: module.IconEyesAdd,
    })),
  ),
  IconEyesDistance: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesDistance').then(module => ({
      default: module.IconEyesDistance,
    })),
  ),
  IconEyesHeight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesHeight').then(module => ({
      default: module.IconEyesHeight,
    })),
  ),
  IconEyesMain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesMain').then(module => ({
      default: module.IconEyesMain,
    })),
  ),
  IconEyesRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesRotate').then(module => ({
      default: module.IconEyesRotate,
    })),
  ),
  IconEyesSize: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesSize').then(module => ({
      default: module.IconEyesSize,
    })),
  ),
  IconEyesVertical: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesVertical').then(module => ({
      default: module.IconEyesVertical,
    })),
  ),
  IconEyesWidth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesWidth').then(module => ({
      default: module.IconEyesWidth,
    })),
  ),
  IconEyesShadow: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEyesShadow').then(module => ({
      default: module.IconEyesShadow,
    })),
  ),
  IconFaceChinHeight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceChinHeight').then(module => ({
      default: module.IconFaceChinHeight,
    })),
  ),
  IconFaceChinWidth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceChinWidth').then(module => ({
      default: module.IconFaceChinWidth,
    })),
  ),
  IconFaceContour: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceContour').then(module => ({
      default: module.IconFaceContour,
    })),
  ),
  IconFaceFix: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceFix').then(module => ({
      default: module.IconFaceFix,
    })),
  ),
  IconFaceForehead: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceForehead').then(module => ({
      default: module.IconFaceForehead,
    })),
  ),
  IconFaceHighlight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceHighlight').then(module => ({
      default: module.IconFaceHighlight,
    })),
  ),
  IconFaceMain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceMain').then(module => ({
      default: module.IconFaceMain,
    })),
  ),
  IconFaceMask: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceMask').then(module => ({
      default: module.IconFaceMask,
    })),
  ),
  IconFaceTool: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceTool').then(module => ({
      default: module.IconFaceTool,
    })),
  ),
  IconFaceWidth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFaceWidth').then(module => ({
      default: module.IconFaceWidth,
    })),
  ),
  IconFadeOut: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFadeOut').then(module => ({
      default: module.IconFadeOut,
    })),
  ),
  IconFadeIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFadeIn').then(module => ({
      default: module.IconFadeIn,
    })),
  ),
  IconFade: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFade').then(module => ({
      default: module.IconFade,
    })),
  ),
  IconStarAddOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStarAddOutline').then(module => ({
      default: module.IconStarAddOutline,
    })),
  ),
  IconFillNew: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFillNew').then(module => ({
      default: module.IconFillNew,
    })),
  ),
  IconFill: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFill').then(module => ({
      default: module.IconFill,
    })),
  ),
  IconFitRectangle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFitRectangle').then(module => ({
      default: module.IconFitRectangle,
    })),
  ),
  IconFitImage: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFitImage').then(module => ({
      default: module.IconFitImage,
    })),
  ),
  IconFlashOff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlashOff').then(module => ({
      default: module.IconFlashOff,
    })),
  ),
  IconFlashOn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlashOn').then(module => ({
      default: module.IconFlashOn,
    })),
  ),
  IconFlipLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlipLeft').then(module => ({
      default: module.IconFlipLeft,
    })),
  ),
  IconFlipRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlipRight').then(module => ({
      default: module.IconFlipRight,
    })),
  ),
  IconFlipHorizontal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlipHorizontal').then(module => ({
      default: module.IconFlipHorizontal,
    })),
  ),
  IconFlipVertical: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlipVertical').then(module => ({
      default: module.IconFlipVertical,
    })),
  ),
  IconFonts: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFonts').then(module => ({
      default: module.IconFonts,
    })),
  ),
  IconFrame: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFrame').then(module => ({
      default: module.IconFrame,
    })),
  ),
  IconFreckles: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFreckles').then(module => ({
      default: module.IconFreckles,
    })),
  ),
  IconFreeCrop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFreeCrop').then(module => ({
      default: module.IconFreeCrop,
    })),
  ),
  IconFreeStyle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFreeStyle').then(module => ({
      default: module.IconFreeStyle,
    })),
  ),
  IconFreeze: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFreeze').then(module => ({
      default: module.IconFreeze,
    })),
  ),
  IconGIF: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGIF').then(module => ({
      default: module.IconGIF,
    })),
  ),
  IconGlow: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGlow').then(module => ({
      default: module.IconGlow,
    })),
  ),
  IconGrain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGrain').then(module => ({
      default: module.IconGrain,
    })),
  ),
  IconGrid: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGrid').then(module => ({
      default: module.IconGrid,
    })),
  ),
  IconGroup: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGroup').then(module => ({
      default: module.IconGroup,
    })),
  ),
  IconHair: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHair').then(module => ({
      default: module.IconHair,
    })),
  ),
  IconHairStyle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHairStyle').then(module => ({
      default: module.IconHairStyle,
    })),
  ),
  IconHashtag: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHashtag').then(module => ({
      default: module.IconHashtag,
    })),
  ),
  IconHeartAdd: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHeartAdd').then(module => ({
      default: module.IconHeartAdd,
    })),
  ),
  IconHighlight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHighlight').then(module => ({
      default: module.IconHighlight,
    })),
  ),
  IconHSL: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHSL').then(module => ({
      default: module.IconHSL,
    })),
  ),
  IconHue: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHue').then(module => ({
      default: module.IconHue,
    })),
  ),
  IconInflate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInflate').then(module => ({
      default: module.IconInflate,
    })),
  ),
  IconInvert: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInvert').then(module => ({
      default: module.IconInvert,
    })),
  ),
  IconItalic: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconItalic').then(module => ({
      default: module.IconItalic,
    })),
  ),
  IconJustify: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconJustify').then(module => ({
      default: module.IconJustify,
    })),
  ),
  IconKeyframeAdd: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconKeyframeAdd').then(module => ({
      default: module.IconKeyframeAdd,
    })),
  ),
  IconKeyboard: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconKeyboard').then(module => ({
      default: module.IconKeyboard,
    })),
  ),
  IconLashes: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLashes').then(module => ({
      default: module.IconLashes,
    })),
  ),
  IconLayers: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLayers').then(module => ({
      default: module.IconLayers,
    })),
  ),
  IconLearn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLearn').then(module => ({
      default: module.IconLearn,
    })),
  ),
  IconLensOctagon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLensOctagon').then(module => ({
      default: module.IconLensOctagon,
    })),
  ),
  IconLensRhombus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLensRhombus').then(module => ({
      default: module.IconLensRhombus,
    })),
  ),
  IconLensTriangle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLensTriangle').then(module => ({
      default: module.IconLensTriangle,
    })),
  ),
  IconLensFlare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLensFlare').then(module => ({
      default: module.IconLensFlare,
    })),
  ),
  IconLetterSpacing: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLetterSpacing').then(module => ({
      default: module.IconLetterSpacing,
    })),
  ),
  IconFolder: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFolder').then(module => ({
      default: module.IconFolder,
    })),
  ),
  IconFolderAdd: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFolderAdd').then(module => ({
      default: module.IconFolderAdd,
    })),
  ),
  IconLines: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLines').then(module => ({
      default: module.IconLines,
    })),
  ),
  IconLipsColor: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLipsColor').then(module => ({
      default: module.IconLipsColor,
    })),
  ),
  IconLipsHeight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLipsHeight').then(module => ({
      default: module.IconLipsHeight,
    })),
  ),
  IconLipsSize: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLipsSize').then(module => ({
      default: module.IconLipsSize,
    })),
  ),
  IconLipsWidth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLipsWidth').then(module => ({
      default: module.IconLipsWidth,
    })),
  ),
  IconLipsVertical: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLipsVertical').then(module => ({
      default: module.IconLipsVertical,
    })),
  ),
  IconLiveOff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLiveOff').then(module => ({
      default: module.IconLiveOff,
    })),
  ),
  IconLiveOn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLiveOn').then(module => ({
      default: module.IconLiveOn,
    })),
  ),
  IconLightLow: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLightLow').then(module => ({
      default: module.IconLightLow,
    })),
  ),
  IconLowercase: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLowercase').then(module => ({
      default: module.IconLowercase,
    })),
  ),
  IconBrushMagic: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrushMagic').then(module => ({
      default: module.IconBrushMagic,
    })),
  ),
  IconMakeupMain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMakeupMain').then(module => ({
      default: module.IconMakeupMain,
    })),
  ),
  IconMargin: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMargin').then(module => ({
      default: module.IconMargin,
    })),
  ),
  IconBrushMarker: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrushMarker').then(module => ({
      default: module.IconBrushMarker,
    })),
  ),
  IconMask: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMask').then(module => ({
      default: module.IconMask,
    })),
  ),
  IconMatt: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMatt').then(module => ({
      default: module.IconMatt,
    })),
  ),
  IconMediaRewind: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMediaRewind').then(module => ({
      default: module.IconMediaRewind,
    })),
  ),
  IconMediaForward: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMediaForward').then(module => ({
      default: module.IconMediaForward,
    })),
  ),
  IconMediaPrevious: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMediaPrevious').then(module => ({
      default: module.IconMediaPrevious,
    })),
  ),
  IconMediaNext: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMediaNext').then(module => ({
      default: module.IconMediaNext,
    })),
  ),
  IconMerge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMerge').then(module => ({
      default: module.IconMerge,
    })),
  ),
  IconBlankWrite: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlankWrite').then(module => ({
      default: module.IconBlankWrite,
    })),
  ),
  IconMirror: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMirror').then(module => ({
      default: module.IconMirror,
    })),
  ),
  IconMotion: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMotion').then(module => ({
      default: module.IconMotion,
    })),
  ),
  IconMoveDown: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoveDown').then(module => ({
      default: module.IconMoveDown,
    })),
  ),
  IconMoveUp: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoveUp').then(module => ({
      default: module.IconMoveUp,
    })),
  ),
  IconMoveVerticalArrows: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoveVerticalArrows').then(module => ({
      default: module.IconMoveVerticalArrows,
    })),
  ),
  IconMoveToFolder: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoveToFolder').then(module => ({
      default: module.IconMoveToFolder,
    })),
  ),
  IconMoveHorizontalArrows: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoveHorizontalArrows').then(module => ({
      default: module.IconMoveHorizontalArrows,
    })),
  ),
  IconMultipleCanvases: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMultipleCanvases').then(module => ({
      default: module.IconMultipleCanvases,
    })),
  ),
  IconMusic: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMusic').then(module => ({
      default: module.IconMusic,
    })),
  ),
  IconBrushNeon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBrushNeon').then(module => ({
      default: module.IconBrushNeon,
    })),
  ),
  IconNoseRemove: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoseRemove').then(module => ({
      default: module.IconNoseRemove,
    })),
  ),
  IconNoseHeight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoseHeight').then(module => ({
      default: module.IconNoseHeight,
    })),
  ),
  IconNoseLift: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoseLift').then(module => ({
      default: module.IconNoseLift,
    })),
  ),
  IconNose: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNose').then(module => ({
      default: module.IconNose,
    })),
  ),
  IconNoseNarrow: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoseNarrow').then(module => ({
      default: module.IconNoseNarrow,
    })),
  ),
  IconNoseTip: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoseTip').then(module => ({
      default: module.IconNoseTip,
    })),
  ),
  IconNoseWidth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoseWidth').then(module => ({
      default: module.IconNoseWidth,
    })),
  ),
  IconObjectAlignBottom: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignBottom').then(module => ({
      default: module.IconObjectAlignBottom,
    })),
  ),
  IconObjectAlignTop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignTop').then(module => ({
      default: module.IconObjectAlignTop,
    })),
  ),
  IconObjectAlignCenterHorizontal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignCenterHorizontal').then(
      module => ({
        default: module.IconObjectAlignCenterHorizontal,
      }),
    ),
  ),
  IconObjectAlignCenterVertical: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignCenterVertical').then(
      module => ({
        default: module.IconObjectAlignCenterVertical,
      }),
    ),
  ),
  IconObjectAlignLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignLeft').then(module => ({
      default: module.IconObjectAlignLeft,
    })),
  ),
  IconObjectAlignRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignRight').then(module => ({
      default: module.IconObjectAlignRight,
    })),
  ),
  IconObjectAlignMiddle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignMiddle').then(module => ({
      default: module.IconObjectAlignMiddle,
    })),
  ),
  IconObjectAlignCenter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectAlignCenter').then(module => ({
      default: module.IconObjectAlignCenter,
    })),
  ),
  IconOpacity: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconOpacity').then(module => ({
      default: module.IconOpacity,
    })),
  ),
  IconOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconOutline').then(module => ({
      default: module.IconOutline,
    })),
  ),
  IconPaste: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPaste').then(module => ({
      default: module.IconPaste,
    })),
  ),
  IconPauseCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPauseCircleFilled').then(module => ({
      default: module.IconPauseCircleFilled,
    })),
  ),
  IconPauseCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPauseCircleOutline').then(module => ({
      default: module.IconPauseCircleOutline,
    })),
  ),
  IconPause: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPause').then(module => ({
      default: module.IconPause,
    })),
  ),
  IconPDF: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPDF').then(module => ({
      default: module.IconPDF,
    })),
  ),
  IconPenCursorClose: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPenCursorClose').then(module => ({
      default: module.IconPenCursorClose,
    })),
  ),
  IconPenCursorMinus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPenCursorMinus').then(module => ({
      default: module.IconPenCursorMinus,
    })),
  ),
  IconPenCursorPlus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPenCursorPlus').then(module => ({
      default: module.IconPenCursorPlus,
    })),
  ),
  IconPenCursor: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPenCursor').then(module => ({
      default: module.IconPenCursor,
    })),
  ),
  IconPersonCutout: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPersonCutout').then(module => ({
      default: module.IconPersonCutout,
    })),
  ),
  IconPerspectiveHorizontal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPerspectiveHorizontal').then(module => ({
      default: module.IconPerspectiveHorizontal,
    })),
  ),
  IconPerspectiveVertical: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPerspectiveVertical').then(module => ({
      default: module.IconPerspectiveVertical,
    })),
  ),
  IconPixelStretch: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPixelStretch').then(module => ({
      default: module.IconPixelStretch,
    })),
  ),
  IconPlayCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlayCircleFilled').then(module => ({
      default: module.IconPlayCircleFilled,
    })),
  ),
  IconPlayCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlayCircleOutline').then(module => ({
      default: module.IconPlayCircleOutline,
    })),
  ),
  IconPlay: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPlay').then(module => ({
      default: module.IconPlay,
    })),
  ),
  IconPolygon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPolygon').then(module => ({
      default: module.IconPolygon,
    })),
  ),
  IconPolygonalLasso: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPolygonalLasso').then(module => ({
      default: module.IconPolygonalLasso,
    })),
  ),
  IconQRCode: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQRCode').then(module => ({
      default: module.IconQRCode,
    })),
  ),
  IconQRShare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQRShare').then(module => ({
      default: module.IconQRShare,
    })),
  ),
  IconQuickTools: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQuickTools').then(module => ({
      default: module.IconQuickTools,
    })),
  ),
  IconRatio1x1: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRatio1x1').then(module => ({
      default: module.IconRatio1x1,
    })),
  ),
  IconRatio4x3: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRatio4x3').then(module => ({
      default: module.IconRatio4x3,
    })),
  ),
  IconRatio: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRatio').then(module => ({
      default: module.IconRatio,
    })),
  ),
  IconRecordOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRecordOutline').then(module => ({
      default: module.IconRecordOutline,
    })),
  ),
  IconRecordFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRecordFilled').then(module => ({
      default: module.IconRecordFilled,
    })),
  ),
  IconUndo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUndo').then(module => ({
      default: module.IconUndo,
    })),
  ),
  IconRedo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRedo').then(module => ({
      default: module.IconRedo,
    })),
  ),
  IconShuffle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShuffle').then(module => ({
      default: module.IconShuffle,
    })),
  ),
  IconRelight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRelight').then(module => ({
      default: module.IconRelight,
    })),
  ),
  IconRemove: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRemove').then(module => ({
      default: module.IconRemove,
    })),
  ),
  IconReplace: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReplace').then(module => ({
      default: module.IconReplace,
    })),
  ),
  IconReshapeEnlarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReshapeEnlarge').then(module => ({
      default: module.IconReshapeEnlarge,
    })),
  ),
  IconReshapeMain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReshapeMain').then(module => ({
      default: module.IconReshapeMain,
    })),
  ),
  IconReshapeReduce: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReshapeReduce').then(module => ({
      default: module.IconReshapeReduce,
    })),
  ),
  IconReshapeRestore: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReshapeRestore').then(module => ({
      default: module.IconReshapeRestore,
    })),
  ),
  IconReshapePro: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReshapePro').then(module => ({
      default: module.IconReshapePro,
    })),
  ),
  IconObjectResize: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconObjectResize').then(module => ({
      default: module.IconObjectResize,
    })),
  ),
  IconRetouch: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRetouch').then(module => ({
      default: module.IconRetouch,
    })),
  ),
  IconReverse: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReverse').then(module => ({
      default: module.IconReverse,
    })),
  ),
  IconRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRotate').then(module => ({
      default: module.IconRotate,
    })),
  ),
  IconRows: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRows').then(module => ({
      default: module.IconRows,
    })),
  ),
  IconRulersOff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRulersOff').then(module => ({
      default: module.IconRulersOff,
    })),
  ),
  IconRulersOn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRulersOn').then(module => ({
      default: module.IconRulersOn,
    })),
  ),
  IconSaturation: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSaturation').then(module => ({
      default: module.IconSaturation,
    })),
  ),
  IconSelectionFreeMinus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionFreeMinus').then(module => ({
      default: module.IconSelectionFreeMinus,
    })),
  ),
  IconSelectionFreePlus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionFreePlus').then(module => ({
      default: module.IconSelectionFreePlus,
    })),
  ),
  IconSelectionFree: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionFree').then(module => ({
      default: module.IconSelectionFree,
    })),
  ),
  IconSelectionRectangleDeselect: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRectangleDeselect').then(
      module => ({
        default: module.IconSelectionRectangleDeselect,
      }),
    ),
  ),
  IconSelectionRectangleEdit: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRectangleEdit').then(module => ({
      default: module.IconSelectionRectangleEdit,
    })),
  ),
  IconSelectionRectangleMinus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRectangleMinus').then(module => ({
      default: module.IconSelectionRectangleMinus,
    })),
  ),
  IconSelectionRectanglePlus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRectanglePlus').then(module => ({
      default: module.IconSelectionRectanglePlus,
    })),
  ),
  IconSelectionRectangle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRectangle').then(module => ({
      default: module.IconSelectionRectangle,
    })),
  ),
  IconSelectionRoundMinus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRoundMinus').then(module => ({
      default: module.IconSelectionRoundMinus,
    })),
  ),
  IconSelectionRoundPlus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRoundPlus').then(module => ({
      default: module.IconSelectionRoundPlus,
    })),
  ),
  IconSelectionRound: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionRound').then(module => ({
      default: module.IconSelectionRound,
    })),
  ),
  IconSelectionSquare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSelectionSquare').then(module => ({
      default: module.IconSelectionSquare,
    })),
  ),
  IconShadowOut: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShadowOut').then(module => ({
      default: module.IconShadowOut,
    })),
  ),
  IconShadowIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShadowIn').then(module => ({
      default: module.IconShadowIn,
    })),
  ),
  IconShapeCrop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShapeCrop').then(module => ({
      default: module.IconShapeCrop,
    })),
  ),
  IconShapeErase: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShapeErase').then(module => ({
      default: module.IconShapeErase,
    })),
  ),
  IconShapeMask: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShapeMask').then(module => ({
      default: module.IconShapeMask,
    })),
  ),
  IconShare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShare').then(module => ({
      default: module.IconShare,
    })),
  ),
  IconSharpen: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSharpen').then(module => ({
      default: module.IconSharpen,
    })),
  ),
  IconShearAngled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShearAngled').then(module => ({
      default: module.IconShearAngled,
    })),
  ),
  IconShearDestroyed: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShearDestroyed').then(module => ({
      default: module.IconShearDestroyed,
    })),
  ),
  IconShearDotted: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShearDotted').then(module => ({
      default: module.IconShearDotted,
    })),
  ),
  IconShearNoise: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShearNoise').then(module => ({
      default: module.IconShearNoise,
    })),
  ),
  IconShearSquare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShearSquare').then(module => ({
      default: module.IconShearSquare,
    })),
  ),
  IconHeartsSimilar: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHeartsSimilar').then(module => ({
      default: module.IconHeartsSimilar,
    })),
  ),
  IconSketch: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSketch').then(module => ({
      default: module.IconSketch,
    })),
  ),
  IconSkinTone: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSkinTone').then(module => ({
      default: module.IconSkinTone,
    })),
  ),
  IconSkyChange: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSkyChange').then(module => ({
      default: module.IconSkyChange,
    })),
  ),
  IconSlice: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSlice').then(module => ({
      default: module.IconSlice,
    })),
  ),
  IconSmooth: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSmooth').then(module => ({
      default: module.IconSmooth,
    })),
  ),
  IconSmudge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSmudge').then(module => ({
      default: module.IconSmudge,
    })),
  ),
  IconSoundOff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSoundOff').then(module => ({
      default: module.IconSoundOff,
    })),
  ),
  IconSoundOn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSoundOn').then(module => ({
      default: module.IconSoundOn,
    })),
  ),
  IconSpacingVertical: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpacingVertical').then(module => ({
      default: module.IconSpacingVertical,
    })),
  ),
  IconSplit: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSplit').then(module => ({
      default: module.IconSplit,
    })),
  ),
  IconSqueeze: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSqueeze').then(module => ({
      default: module.IconSqueeze,
    })),
  ),
  IconSticker: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSticker').then(module => ({
      default: module.IconSticker,
    })),
  ),
  IconStopCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStopCircleFilled').then(module => ({
      default: module.IconStopCircleFilled,
    })),
  ),
  IconStop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStop').then(module => ({
      default: module.IconStop,
    })),
  ),
  IconStretchSwirlLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStretchSwirlLeft').then(module => ({
      default: module.IconStretchSwirlLeft,
    })),
  ),
  IconStretchSwirlRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStretchSwirlRight').then(module => ({
      default: module.IconStretchSwirlRight,
    })),
  ),
  IconStretchWrap: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStretchWrap').then(module => ({
      default: module.IconStretchWrap,
    })),
  ),
  IconTextStroke: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextStroke').then(module => ({
      default: module.IconTextStroke,
    })),
  ),
  IconStyleTransfer: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStyleTransfer').then(module => ({
      default: module.IconStyleTransfer,
    })),
  ),
  IconTagFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTagFilled').then(module => ({
      default: module.IconTagFilled,
    })),
  ),
  IconTeethOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTeethOutline').then(module => ({
      default: module.IconTeethOutline,
    })),
  ),
  IconTemperature: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTemperature').then(module => ({
      default: module.IconTemperature,
    })),
  ),
  IconTextBrush: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextBrush').then(module => ({
      default: module.IconTextBrush,
    })),
  ),
  IconTextHighlight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextHighlight').then(module => ({
      default: module.IconTextHighlight,
    })),
  ),
  IconTextStaff: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextStaff').then(module => ({
      default: module.IconTextStaff,
    })),
  ),
  IconTextToBox: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextToBox').then(module => ({
      default: module.IconTextToBox,
    })),
  ),
  IconText: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconText').then(module => ({
      default: module.IconText,
    })),
  ),
  IconTexture: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTexture').then(module => ({
      default: module.IconTexture,
    })),
  ),
  IconTiltShiftRadial: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTiltShiftRadial').then(module => ({
      default: module.IconTiltShiftRadial,
    })),
  ),
  IconTiltShiftLinear: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTiltShiftLinear').then(module => ({
      default: module.IconTiltShiftLinear,
    })),
  ),
  IconDropOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDropOutline').then(module => ({
      default: module.IconDropOutline,
    })),
  ),
  IconTimer: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTimer').then(module => ({
      default: module.IconTimer,
    })),
  ),
  IconFrameTrim: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFrameTrim').then(module => ({
      default: module.IconFrameTrim,
    })),
  ),
  IconUnderline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnderline').then(module => ({
      default: module.IconUnderline,
    })),
  ),
  IconUngroup: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUngroup').then(module => ({
      default: module.IconUngroup,
    })),
  ),
  IconUppercase: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUppercase').then(module => ({
      default: module.IconUppercase,
    })),
  ),
  IconVectorTransform: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVectorTransform').then(module => ({
      default: module.IconVectorTransform,
    })),
  ),
  IconVideoTutorial: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVideoTutorial').then(module => ({
      default: module.IconVideoTutorial,
    })),
  ),
  IconVignette: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVignette').then(module => ({
      default: module.IconVignette,
    })),
  ),
  IconVoiceEffects: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVoiceEffects').then(module => ({
      default: module.IconVoiceEffects,
    })),
  ),
  IconVoiceover: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVoiceover').then(module => ({
      default: module.IconVoiceover,
    })),
  ),
  IconEffectsVX: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEffectsVX').then(module => ({
      default: module.IconEffectsVX,
    })),
  ),
  IconWrinkle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWrinkle').then(module => ({
      default: module.IconWrinkle,
    })),
  ),
  IconAudioExtract: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAudioExtract').then(module => ({
      default: module.IconAudioExtract,
    })),
  ),
  IconAudioRecover: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAudioRecover').then(module => ({
      default: module.IconAudioRecover,
    })),
  ),
  IconAudioDetach: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAudioDetach').then(module => ({
      default: module.IconAudioDetach,
    })),
  ),
  IconTextStyles: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextStyles').then(module => ({
      default: module.IconTextStyles,
    })),
  ),
  IconTrackManual: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTrackManual').then(module => ({
      default: module.IconTrackManual,
    })),
  ),
  IconResizeDiagonal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconResizeDiagonal').then(module => ({
      default: module.IconResizeDiagonal,
    })),
  ),
  IconColorChooser: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColorChooser').then(module => ({
      default: module.IconColorChooser,
    })),
  ),
  Icon1x1: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon1x1').then(module => ({
      default: module.Icon1x1,
    })),
  ),
  Icon2x1: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon2x1').then(module => ({
      default: module.Icon2x1,
    })),
  ),
  Icon3x2: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x2').then(module => ({
      default: module.Icon3x2,
    })),
  ),
  Icon3x4: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x4').then(module => ({
      default: module.Icon3x4,
    })),
  ),
  Icon16x9: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon16x9').then(module => ({
      default: module.Icon16x9,
    })),
  ),
  IconAllSizes: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAllSizes').then(module => ({
      default: module.IconAllSizes,
    })),
  ),
  IconTemplates: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTemplates').then(module => ({
      default: module.IconTemplates,
    })),
  ),
  IconImageBackground: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconImageBackground').then(module => ({
      default: module.IconImageBackground,
    })),
  ),
  IconBlog: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlog').then(module => ({
      default: module.IconBlog,
    })),
  ),
  IconAndroid: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAndroid').then(module => ({
      default: module.IconAndroid,
    })),
  ),
  IconAndroidColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAndroidColored').then(module => ({
      default: module.IconAndroidColored,
    })),
  ),
  IconApple: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconApple').then(module => ({
      default: module.IconApple,
    })),
  ),
  IconAppleColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAppleColored').then(module => ({
      default: module.IconAppleColored,
    })),
  ),
  IconDrive: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDrive').then(module => ({
      default: module.IconDrive,
    })),
  ),
  IconDriveColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDriveColored').then(module => ({
      default: module.IconDriveColored,
    })),
  ),
  IconDropBox: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDropBox').then(module => ({
      default: module.IconDropBox,
    })),
  ),
  IconDropBoxColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDropBoxColored').then(module => ({
      default: module.IconDropBoxColored,
    })),
  ),
  IconFacebook: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFacebook').then(module => ({
      default: module.IconFacebook,
    })),
  ),
  IconFacebookColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFacebookColored').then(module => ({
      default: module.IconFacebookColored,
    })),
  ),
  IconGoogle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGoogle').then(module => ({
      default: module.IconGoogle,
    })),
  ),
  IconGoogleColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGoogleColored').then(module => ({
      default: module.IconGoogleColored,
    })),
  ),
  IconGooglePlay: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGooglePlay').then(module => ({
      default: module.IconGooglePlay,
    })),
  ),
  IconGooglePlayColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGooglePlayColored').then(module => ({
      default: module.IconGooglePlayColored,
    })),
  ),
  IconInstagram: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInstagram').then(module => ({
      default: module.IconInstagram,
    })),
  ),
  IconInstagramColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInstagramColored').then(module => ({
      default: module.IconInstagramColored,
    })),
  ),
  IconLinkedIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLinkedIn').then(module => ({
      default: module.IconLinkedIn,
    })),
  ),
  IconLinkedInColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLinkedInColored').then(module => ({
      default: module.IconLinkedInColored,
    })),
  ),
  IconMicrosoft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMicrosoft').then(module => ({
      default: module.IconMicrosoft,
    })),
  ),
  IconMicrosoftColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMicrosoftColored').then(module => ({
      default: module.IconMicrosoftColored,
    })),
  ),
  IconPayPal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPayPal').then(module => ({
      default: module.IconPayPal,
    })),
  ),
  IconPayPalColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPayPalColored').then(module => ({
      default: module.IconPayPalColored,
    })),
  ),
  IconPinterest: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPinterest').then(module => ({
      default: module.IconPinterest,
    })),
  ),
  IconPinterestColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPinterestColored').then(module => ({
      default: module.IconPinterestColored,
    })),
  ),
  IconQQ: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQQ').then(module => ({
      default: module.IconQQ,
    })),
  ),
  IconQQColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconQQColored').then(module => ({
      default: module.IconQQColored,
    })),
  ),
  IconRSS: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRSS').then(module => ({
      default: module.IconRSS,
    })),
  ),
  IconRSSColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRSSColored').then(module => ({
      default: module.IconRSSColored,
    })),
  ),
  IconSnapChat: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSnapChat').then(module => ({
      default: module.IconSnapChat,
    })),
  ),
  IconSnapChatColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSnapChatColored').then(module => ({
      default: module.IconSnapChatColored,
    })),
  ),
  IconTikTok: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTikTok').then(module => ({
      default: module.IconTikTok,
    })),
  ),
  IconTikTokColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTikTokColored').then(module => ({
      default: module.IconTikTokColored,
    })),
  ),
  IconTLine: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTLine').then(module => ({
      default: module.IconTLine,
    })),
  ),
  IconTLineColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTLineColored').then(module => ({
      default: module.IconTLineColored,
    })),
  ),
  IconTumblr: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTumblr').then(module => ({
      default: module.IconTumblr,
    })),
  ),
  IconTumblrColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTumblrColored').then(module => ({
      default: module.IconTumblrColored,
    })),
  ),
  IconTwitter: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTwitter').then(module => ({
      default: module.IconTwitter,
    })),
  ),
  IconTwitterColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTwitterColored').then(module => ({
      default: module.IconTwitterColored,
    })),
  ),
  IconUMobile: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUMobile').then(module => ({
      default: module.IconUMobile,
    })),
  ),
  IconUMobileColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUMobileColored').then(module => ({
      default: module.IconUMobileColored,
    })),
  ),
  IconYouTube: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconYouTube').then(module => ({
      default: module.IconYouTube,
    })),
  ),
  IconYouTubeColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconYouTubeColored').then(module => ({
      default: module.IconYouTubeColored,
    })),
  ),
  IconWindows: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWindows').then(module => ({
      default: module.IconWindows,
    })),
  ),
  IconWindowsColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWindowsColored').then(module => ({
      default: module.IconWindowsColored,
    })),
  ),
  IconWhatsApp: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWhatsApp').then(module => ({
      default: module.IconWhatsApp,
    })),
  ),
  IconWhatsAppColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWhatsAppColored').then(module => ({
      default: module.IconWhatsAppColored,
    })),
  ),
  IconWeibo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWeibo').then(module => ({
      default: module.IconWeibo,
    })),
  ),
  IconWeiboColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWeiboColored').then(module => ({
      default: module.IconWeiboColored,
    })),
  ),
  IconWeChat: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWeChat').then(module => ({
      default: module.IconWeChat,
    })),
  ),
  IconWeChatColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWeChatColored').then(module => ({
      default: module.IconWeChatColored,
    })),
  ),
  IconVK: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVK').then(module => ({
      default: module.IconVK,
    })),
  ),
  IconVKColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVKColored').then(module => ({
      default: module.IconVKColored,
    })),
  ),
  IconCoupon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCoupon').then(module => ({
      default: module.IconCoupon,
    })),
  ),
  IconLeaderboard: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLeaderboard').then(module => ({
      default: module.IconLeaderboard,
    })),
  ),
  IconMoodBoard: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoodBoard').then(module => ({
      default: module.IconMoodBoard,
    })),
  ),
  IconSun: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSun').then(module => ({
      default: module.IconSun,
    })),
  ),
  IconMoon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoon').then(module => ({
      default: module.IconMoon,
    })),
  ),
  IconMobilePayment: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMobilePayment').then(module => ({
      default: module.IconMobilePayment,
    })),
  ),
  IconCPU: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCPU').then(module => ({
      default: module.IconCPU,
    })),
  ),
  IconCheckboxMinus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCheckboxMinus').then(module => ({
      default: module.IconCheckboxMinus,
    })),
  ),
  IconCapitalLetterA: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterA').then(module => ({
      default: module.IconCapitalLetterA,
    })),
  ),
  IconCapitalLetterH: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterH').then(module => ({
      default: module.IconCapitalLetterH,
    })),
  ),
  IconCapitalLetterL: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterL').then(module => ({
      default: module.IconCapitalLetterL,
    })),
  ),
  IconCapitalLetterS: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterS').then(module => ({
      default: module.IconCapitalLetterS,
    })),
  ),
  IconCapitalLetterB: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterB').then(module => ({
      default: module.IconCapitalLetterB,
    })),
  ),
  IconCapitalLetterG: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterG').then(module => ({
      default: module.IconCapitalLetterG,
    })),
  ),
  IconCapitalLetterR: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterR').then(module => ({
      default: module.IconCapitalLetterR,
    })),
  ),
  IconPalettesColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPalettesColored').then(module => ({
      default: module.IconPalettesColored,
    })),
  ),
  IconFileUpload: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFileUpload').then(module => ({
      default: module.IconFileUpload,
    })),
  ),
  IconWorkspace: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWorkspace').then(module => ({
      default: module.IconWorkspace,
    })),
  ),
  IconTextNew: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextNew').then(module => ({
      default: module.IconTextNew,
    })),
  ),
  IconTextTry: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextTry').then(module => ({
      default: module.IconTextTry,
    })),
  ),
  IconTextMax: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextMax').then(module => ({
      default: module.IconTextMax,
    })),
  ),
  IconTextPlus: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextPlus').then(module => ({
      default: module.IconTextPlus,
    })),
  ),
  IconTextPro: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextPro').then(module => ({
      default: module.IconTextPro,
    })),
  ),
  IconBlogBanner: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlogBanner').then(module => ({
      default: module.IconBlogBanner,
    })),
  ),
  IconCustomSize: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCustomSize').then(module => ({
      default: module.IconCustomSize,
    })),
  ),
  IconEmailHeader: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmailHeader').then(module => ({
      default: module.IconEmailHeader,
    })),
  ),
  IconFlyer: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFlyer').then(module => ({
      default: module.IconFlyer,
    })),
  ),
  IconPatreon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPatreon').then(module => ({
      default: module.IconPatreon,
    })),
  ),
  IconPatreonColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPatreonColored').then(module => ({
      default: module.IconPatreonColored,
    })),
  ),
  IconPoster: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPoster').then(module => ({
      default: module.IconPoster,
    })),
  ),
  IconSpotify: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpotify').then(module => ({
      default: module.IconSpotify,
    })),
  ),
  IconSpotifyColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSpotifyColored').then(module => ({
      default: module.IconSpotifyColored,
    })),
  ),
  IconTwitch: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTwitch').then(module => ({
      default: module.IconTwitch,
    })),
  ),
  IconTwitchColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTwitchColored').then(module => ({
      default: module.IconTwitchColored,
    })),
  ),
  IconWebsiteBanner: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWebsiteBanner').then(module => ({
      default: module.IconWebsiteBanner,
    })),
  ),
  IconZoom: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconZoom').then(module => ({
      default: module.IconZoom,
    })),
  ),
  IconZoomColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconZoomColored').then(module => ({
      default: module.IconZoomColored,
    })),
  ),
  IconCFRP: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCFRP').then(module => ({
      default: module.IconCFRP,
    })),
  ),
  IconEraseRestore: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEraseRestore').then(module => ({
      default: module.IconEraseRestore,
    })),
  ),
  IconUpscale: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUpscale').then(module => ({
      default: module.IconUpscale,
    })),
  ),
  IconSVG: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSVG').then(module => ({
      default: module.IconSVG,
    })),
  ),
  IconFeedback: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFeedback').then(module => ({
      default: module.IconFeedback,
    })),
  ),
  IconAIGen: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAIGen').then(module => ({
      default: module.IconAIGen,
    })),
  ),
  IconUnionSelection: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnionSelection').then(module => ({
      default: module.IconUnionSelection,
    })),
  ),
  IconMoreWindows: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMoreWindows').then(module => ({
      default: module.IconMoreWindows,
    })),
  ),
  IconCreate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCreate').then(module => ({
      default: module.IconCreate,
    })),
  ),
  IconAsk: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAsk').then(module => ({
      default: module.IconAsk,
    })),
  ),
  IconAIGenerator: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAIGenerator').then(module => ({
      default: module.IconAIGenerator,
    })),
  ),
  IconClick: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconClick').then(module => ({
      default: module.IconClick,
    })),
  ),
  IconDeselect: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDeselect').then(module => ({
      default: module.IconDeselect,
    })),
  ),
  IconDevelop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDevelop').then(module => ({
      default: module.IconDevelop,
    })),
  ),
  IconPrint: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPrint').then(module => ({
      default: module.IconPrint,
    })),
  ),
  IconOverlay: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconOverlay').then(module => ({
      default: module.IconOverlay,
    })),
  ),
  IconTextBeta: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextBeta').then(module => ({
      default: module.IconTextBeta,
    })),
  ),
  IconAIAvatar: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAIAvatar').then(module => ({
      default: module.IconAIAvatar,
    })),
  ),
  IconNotificationHighlightsOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNotificationHighlightsOutline').then(
      module => ({
        default: module.IconNotificationHighlightsOutline,
      }),
    ),
  ),
  IconNotificationsOffOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNotificationsOffOutline').then(module => ({
      default: module.IconNotificationsOffOutline,
    })),
  ),
  IconNotificationFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNotificationFilled').then(module => ({
      default: module.IconNotificationFilled,
    })),
  ),
  IconAnimateLoop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnimateLoop').then(module => ({
      default: module.IconAnimateLoop,
    })),
  ),
  IconAnimateOut: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnimateOut').then(module => ({
      default: module.IconAnimateOut,
    })),
  ),
  IconAnimateIn: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAnimateIn').then(module => ({
      default: module.IconAnimateIn,
    })),
  ),
  IconSorting: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSorting').then(module => ({
      default: module.IconSorting,
    })),
  ),
  IconAddComment: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAddComment').then(module => ({
      default: module.IconAddComment,
    })),
  ),
  IconPortalColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPortalColored').then(module => ({
      default: module.IconPortalColored,
    })),
  ),
  IconPortal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPortal').then(module => ({
      default: module.IconPortal,
    })),
  ),
  IconShapes: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShapes').then(module => ({
      default: module.IconShapes,
    })),
  ),
  IconAIExpand: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAIExpand').then(module => ({
      default: module.IconAIExpand,
    })),
  ),
  IconBlush: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBlush').then(module => ({
      default: module.IconBlush,
    })),
  ),
  IconAI: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAI').then(module => ({
      default: module.IconAI,
    })),
  ),
  IconTextAI: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextAI').then(module => ({
      default: module.IconTextAI,
    })),
  ),
  IconSlideShow: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSlideShow').then(module => ({
      default: module.IconSlideShow,
    })),
  ),
  IconNone: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNone').then(module => ({
      default: module.IconNone,
    })),
  ),
  IconAIReplace: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAIReplace').then(module => ({
      default: module.IconAIReplace,
    })),
  ),
  IconPicsartCircleColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPicsartCircleColored').then(module => ({
      default: module.IconPicsartCircleColored,
    })),
  ),
  IconColorAppColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColorAppColored').then(module => ({
      default: module.IconColorAppColored,
    })),
  ),
  IconPicsartCircle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPicsartCircle').then(module => ({
      default: module.IconPicsartCircle,
    })),
  ),
  IconColorApp: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColorApp').then(module => ({
      default: module.IconColorApp,
    })),
  ),
  IconEditCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEditCircleFilled').then(module => ({
      default: module.IconEditCircleFilled,
    })),
  ),
  IconFollowingUserCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFollowingUserCircleFilled').then(
      module => ({
        default: module.IconFollowingUserCircleFilled,
      }),
    ),
  ),
  IconImageCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconImageCircleFilled').then(module => ({
      default: module.IconImageCircleFilled,
    })),
  ),
  IconUnlockCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconUnlockCircleFilled').then(module => ({
      default: module.IconUnlockCircleFilled,
    })),
  ),
  IconFollowUserCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFollowUserCircleFilled').then(module => ({
      default: module.IconFollowUserCircleFilled,
    })),
  ),
  IconFollowingHashtagCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFollowingHashtagCircleFilled').then(
      module => ({
        default: module.IconFollowingHashtagCircleFilled,
      }),
    ),
  ),
  IconLipsMain: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLipsMain').then(module => ({
      default: module.IconLipsMain,
    })),
  ),
  IconSendCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSendCircleFilled').then(module => ({
      default: module.IconSendCircleFilled,
    })),
  ),
  IconLockCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLockCircleFilled').then(module => ({
      default: module.IconLockCircleFilled,
    })),
  ),
  IconRedEyeOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRedEyeOutline').then(module => ({
      default: module.IconRedEyeOutline,
    })),
  ),
  IconFollowHashtagCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFollowHashtagCircleFilled').then(
      module => ({
        default: module.IconFollowHashtagCircleFilled,
      }),
    ),
  ),
  IconGifCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGifCircleFilled').then(module => ({
      default: module.IconGifCircleFilled,
    })),
  ),
  IconResizeCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconResizeCircleFilled').then(module => ({
      default: module.IconResizeCircleFilled,
    })),
  ),
  IconRotateCircleFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRotateCircleFilled').then(module => ({
      default: module.IconRotateCircleFilled,
    })),
  ),
  IconFolderMyFonts: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFolderMyFonts').then(module => ({
      default: module.IconFolderMyFonts,
    })),
  ),
  IconInfluencer: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInfluencer').then(module => ({
      default: module.IconInfluencer,
    })),
  ),
  IconMessanger: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMessanger').then(module => ({
      default: module.IconMessanger,
    })),
  ),
  IconCloudLoading: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCloudLoading').then(module => ({
      default: module.IconCloudLoading,
    })),
  ),
  IconHobby: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHobby').then(module => ({
      default: module.IconHobby,
    })),
  ),
  IconTickLargeUnderline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTickLargeUnderline').then(module => ({
      default: module.IconTickLargeUnderline,
    })),
  ),
  IconAds: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAds').then(module => ({
      default: module.IconAds,
    })),
  ),
  IconMessangerColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMessangerColored').then(module => ({
      default: module.IconMessangerColored,
    })),
  ),
  IconFun: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFun').then(module => ({
      default: module.IconFun,
    })),
  ),
  IconRestorePurchase: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRestorePurchase').then(module => ({
      default: module.IconRestorePurchase,
    })),
  ),
  IconTshirt: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTshirt').then(module => ({
      default: module.IconTshirt,
    })),
  ),
  IconStrikeThrough: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStrikeThrough').then(module => ({
      default: module.IconStrikeThrough,
    })),
  ),
  IconPresentations: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPresentations').then(module => ({
      default: module.IconPresentations,
    })),
  ),
  IconTemplate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTemplate').then(module => ({
      default: module.IconTemplate,
    })),
  ),
  IconBorder: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBorder').then(module => ({
      default: module.IconBorder,
    })),
  ),
  IconBeginner: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBeginner').then(module => ({
      default: module.IconBeginner,
    })),
  ),
  IconShop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShop').then(module => ({
      default: module.IconShop,
    })),
  ),
  IconAlignment: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlignment').then(module => ({
      default: module.IconAlignment,
    })),
  ),
  IconSchool: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSchool').then(module => ({
      default: module.IconSchool,
    })),
  ),
  IconEfekt: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEfekt').then(module => ({
      default: module.IconEfekt,
    })),
  ),
  IconIntermediate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconIntermediate').then(module => ({
      default: module.IconIntermediate,
    })),
  ),
  IconJob: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconJob').then(module => ({
      default: module.IconJob,
    })),
  ),
  IconTextFormat: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextFormat').then(module => ({
      default: module.IconTextFormat,
    })),
  ),
  IconAdvanced: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAdvanced').then(module => ({
      default: module.IconAdvanced,
    })),
  ),
  IconPromote: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPromote').then(module => ({
      default: module.IconPromote,
    })),
  ),
  IconSport: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSport').then(module => ({
      default: module.IconSport,
    })),
  ),
  Icon3x2Landscape: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x2Landscape').then(module => ({
      default: module.Icon3x2Landscape,
    })),
  ),
  Icon3x2LandscapeRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x2LandscapeRotate').then(module => ({
      default: module.Icon3x2LandscapeRotate,
    })),
  ),
  Icon3x2Portrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x2Portrait').then(module => ({
      default: module.Icon3x2Portrait,
    })),
  ),
  Icon3x2PortraitRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x2PortraitRotate').then(module => ({
      default: module.Icon3x2PortraitRotate,
    })),
  ),
  Icon3x4Landscape: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x4Landscape').then(module => ({
      default: module.Icon3x4Landscape,
    })),
  ),
  Icon3x4LandscapeRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x4LandscapeRotate').then(module => ({
      default: module.Icon3x4LandscapeRotate,
    })),
  ),
  Icon3x4PortraitRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x4PortraitRotate').then(module => ({
      default: module.Icon3x4PortraitRotate,
    })),
  ),
  Icon3x4Portrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3x4Portrait').then(module => ({
      default: module.Icon3x4Portrait,
    })),
  ),
  Icon16x9Portrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon16x9Portrait').then(module => ({
      default: module.Icon16x9Portrait,
    })),
  ),
  Icon16x9PortraitRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon16x9PortraitRotate').then(module => ({
      default: module.Icon16x9PortraitRotate,
    })),
  ),
  IconFontSize: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFontSize').then(module => ({
      default: module.IconFontSize,
    })),
  ),
  IconMultiSelect: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMultiSelect').then(module => ({
      default: module.IconMultiSelect,
    })),
  ),
  IconTextToSticker: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextToSticker').then(module => ({
      default: module.IconTextToSticker,
    })),
  ),
  Icon3DRotate: lazy(() =>
    import('@picsart/design-system/foundation/icons/Icon3DRotate').then(module => ({
      default: module.Icon3DRotate,
    })),
  ),
  IconArrowLeftRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowLeftRight').then(module => ({
      default: module.IconArrowLeftRight,
    })),
  ),
  IconVideoEditor: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVideoEditor').then(module => ({
      default: module.IconVideoEditor,
    })),
  ),
  IconPin: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPin').then(module => ({
      default: module.IconPin,
    })),
  ),
  IconNoResult: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoResult').then(module => ({
      default: module.IconNoResult,
    })),
  ),
  IconInfluencerFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconInfluencerFilled').then(module => ({
      default: module.IconInfluencerFilled,
    })),
  ),
  IconCapitalLetterY: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterY').then(module => ({
      default: module.IconCapitalLetterY,
    })),
  ),
  IconCapitalLetterM: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterM').then(module => ({
      default: module.IconCapitalLetterM,
    })),
  ),
  IconCapitalLetterK: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterK').then(module => ({
      default: module.IconCapitalLetterK,
    })),
  ),
  IconCapitalLetterC: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterC').then(module => ({
      default: module.IconCapitalLetterC,
    })),
  ),
  IconAddAudio: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAddAudio').then(module => ({
      default: module.IconAddAudio,
    })),
  ),
  IconSubtitleSquare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSubtitleSquare').then(module => ({
      default: module.IconSubtitleSquare,
    })),
  ),
  IconAdmin: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAdmin').then(module => ({
      default: module.IconAdmin,
    })),
  ),
  IconSubtitle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSubtitle').then(module => ({
      default: module.IconSubtitle,
    })),
  ),
  IconTextToVideo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextToVideo').then(module => ({
      default: module.IconTextToVideo,
    })),
  ),
  IconNoiseRemove: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconNoiseRemove').then(module => ({
      default: module.IconNoiseRemove,
    })),
  ),
  IconTextMask: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextMask').then(module => ({
      default: module.IconTextMask,
    })),
  ),
  IconFire: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFire').then(module => ({
      default: module.IconFire,
    })),
  ),
  IconHips: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHips').then(module => ({
      default: module.IconHips,
    })),
  ),
  IconShoulders: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShoulders').then(module => ({
      default: module.IconShoulders,
    })),
  ),
  IconHeight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHeight').then(module => ({
      default: module.IconHeight,
    })),
  ),
  IconWaist: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWaist').then(module => ({
      default: module.IconWaist,
    })),
  ),
  IconLegs: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLegs').then(module => ({
      default: module.IconLegs,
    })),
  ),
  IconBody: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBody').then(module => ({
      default: module.IconBody,
    })),
  ),
  IconDislike: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDislike').then(module => ({
      default: module.IconDislike,
    })),
  ),
  IconLike: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLike').then(module => ({
      default: module.IconLike,
    })),
  ),
  IconEmojiLoveFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmojiLoveFilled').then(module => ({
      default: module.IconEmojiLoveFilled,
    })),
  ),
  IconEmojiLike: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmojiLike').then(module => ({
      default: module.IconEmojiLike,
    })),
  ),
  IconEmojiLikeFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmojiLikeFilled').then(module => ({
      default: module.IconEmojiLikeFilled,
    })),
  ),
  IconEmojiDislike: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEmojiDislike').then(module => ({
      default: module.IconEmojiDislike,
    })),
  ),
  IconHeal: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHeal').then(module => ({
      default: module.IconHeal,
    })),
  ),
  IconProfileAddFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconProfileAddFilled').then(module => ({
      default: module.IconProfileAddFilled,
    })),
  ),
  IconCommentFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCommentFilled').then(module => ({
      default: module.IconCommentFilled,
    })),
  ),
  IconImageFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconImageFilled').then(module => ({
      default: module.IconImageFilled,
    })),
  ),
  IconEditFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEditFilled').then(module => ({
      default: module.IconEditFilled,
    })),
  ),
  IconStickerFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStickerFilled').then(module => ({
      default: module.IconStickerFilled,
    })),
  ),
  IconAdminFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAdminFilled').then(module => ({
      default: module.IconAdminFilled,
    })),
  ),
  IconArrowShareFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowShareFilled').then(module => ({
      default: module.IconArrowShareFilled,
    })),
  ),
  IconCapitalLetterW: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterW').then(module => ({
      default: module.IconCapitalLetterW,
    })),
  ),
  IconPositionDownLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPositionDownLeft').then(module => ({
      default: module.IconPositionDownLeft,
    })),
  ),
  IconPositionDownRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPositionDownRight').then(module => ({
      default: module.IconPositionDownRight,
    })),
  ),
  IconWatermarkDiagonalLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWatermarkDiagonalLeft').then(module => ({
      default: module.IconWatermarkDiagonalLeft,
    })),
  ),
  IconPositionTopLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPositionTopLeft').then(module => ({
      default: module.IconPositionTopLeft,
    })),
  ),
  IconPositionTopRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPositionTopRight').then(module => ({
      default: module.IconPositionTopRight,
    })),
  ),
  IconWatermarkDiagonalRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWatermarkDiagonalRight').then(module => ({
      default: module.IconWatermarkDiagonalRight,
    })),
  ),
  IconListNumbering: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconListNumbering').then(module => ({
      default: module.IconListNumbering,
    })),
  ),
  IconArrowDownLeftLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowDownLeftLarge').then(module => ({
      default: module.IconArrowDownLeftLarge,
    })),
  ),
  IconArrowDownRightLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowDownRightLarge').then(module => ({
      default: module.IconArrowDownRightLarge,
    })),
  ),
  IconArrowUpRightLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowUpRightLarge').then(module => ({
      default: module.IconArrowUpRightLarge,
    })),
  ),
  IconArrowUpLeftLarge: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconArrowUpLeftLarge').then(module => ({
      default: module.IconArrowUpLeftLarge,
    })),
  ),
  IconBetaMiniApp: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBetaMiniApp').then(module => ({
      default: module.IconBetaMiniApp,
    })),
  ),
  IconBetaFilled: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconBetaFilled').then(module => ({
      default: module.IconBetaFilled,
    })),
  ),
  IconHighlightVideo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHighlightVideo').then(module => ({
      default: module.IconHighlightVideo,
    })),
  ),
  IconCombine: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCombine').then(module => ({
      default: module.IconCombine,
    })),
  ),
  IconLayerDisable: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLayerDisable').then(module => ({
      default: module.IconLayerDisable,
    })),
  ),
  IconTouchPointInstance: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTouchPointInstance').then(module => ({
      default: module.IconTouchPointInstance,
    })),
  ),
  IconEffectsCustom: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEffectsCustom').then(module => ({
      default: module.IconEffectsCustom,
    })),
  ),
  IconCapitalLetterX: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCapitalLetterX').then(module => ({
      default: module.IconCapitalLetterX,
    })),
  ),
  IconTextSize25Percent: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextSize25Percent').then(module => ({
      default: module.IconTextSize25Percent,
    })),
  ),
  IconTextSize30Percent: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextSize30Percent').then(module => ({
      default: module.IconTextSize30Percent,
    })),
  ),
  IconTextSize50Percent: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextSize50Percent').then(module => ({
      default: module.IconTextSize50Percent,
    })),
  ),
  IconAlbum: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAlbum').then(module => ({
      default: module.IconAlbum,
    })),
  ),
  IconChat: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChat').then(module => ({
      default: module.IconChat,
    })),
  ),
  IconAmazonColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAmazonColored').then(module => ({
      default: module.IconAmazonColored,
    })),
  ),
  IconAmazonMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAmazonMonochrome').then(module => ({
      default: module.IconAmazonMonochrome,
    })),
  ),
  IconEbayColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEbayColored').then(module => ({
      default: module.IconEbayColored,
    })),
  ),
  IconDepopMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDepopMonochrome').then(module => ({
      default: module.IconDepopMonochrome,
    })),
  ),
  IconDepopColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDepopColored').then(module => ({
      default: module.IconDepopColored,
    })),
  ),
  IconEbayMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEbayMonochrome').then(module => ({
      default: module.IconEbayMonochrome,
    })),
  ),
  IconEtsyColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEtsyColored').then(module => ({
      default: module.IconEtsyColored,
    })),
  ),
  IconEtsyMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEtsyMonochrome').then(module => ({
      default: module.IconEtsyMonochrome,
    })),
  ),
  IconFBMarketplaceColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFBMarketplaceColored').then(module => ({
      default: module.IconFBMarketplaceColored,
    })),
  ),
  IconFBMarketplaceMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFBMarketplaceMonochrome').then(module => ({
      default: module.IconFBMarketplaceMonochrome,
    })),
  ),
  IconLazadaColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLazadaColored').then(module => ({
      default: module.IconLazadaColored,
    })),
  ),
  IconLazadaMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLazadaMonochrome').then(module => ({
      default: module.IconLazadaMonochrome,
    })),
  ),
  IconMercadoLibreColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMercadoLibreColored').then(module => ({
      default: module.IconMercadoLibreColored,
    })),
  ),
  IconMercadoLibreMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMercadoLibreMonochrome').then(module => ({
      default: module.IconMercadoLibreMonochrome,
    })),
  ),
  IconMercariColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMercariColored').then(module => ({
      default: module.IconMercariColored,
    })),
  ),
  IconMercariMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMercariMonochrome').then(module => ({
      default: module.IconMercariMonochrome,
    })),
  ),
  IconPoshmarkColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPoshmarkColored').then(module => ({
      default: module.IconPoshmarkColored,
    })),
  ),
  IconPoshmarkMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPoshmarkMonochrome').then(module => ({
      default: module.IconPoshmarkMonochrome,
    })),
  ),
  IconShopeeColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopeeColored').then(module => ({
      default: module.IconShopeeColored,
    })),
  ),
  IconShopeeMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopeeMonochrome').then(module => ({
      default: module.IconShopeeMonochrome,
    })),
  ),
  IconShopifyColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifyColored').then(module => ({
      default: module.IconShopifyColored,
    })),
  ),
  IconShopifyMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifyMonochrome').then(module => ({
      default: module.IconShopifyMonochrome,
    })),
  ),
  IconTextGoldColoredIsolated: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextGoldColoredIsolated').then(module => ({
      default: module.IconTextGoldColoredIsolated,
    })),
  ),
  IconTextPlusColoredIsolated: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextPlusColoredIsolated').then(module => ({
      default: module.IconTextPlusColoredIsolated,
    })),
  ),
  IconTextProColoredIsolated: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextProColoredIsolated').then(module => ({
      default: module.IconTextProColoredIsolated,
    })),
  ),
  IconVintedMonochrome: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVintedMonochrome').then(module => ({
      default: module.IconVintedMonochrome,
    })),
  ),
  IconVintedColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconVintedColored').then(module => ({
      default: module.IconVintedColored,
    })),
  ),
  IconTextSize100Percent: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextSize100Percent').then(module => ({
      default: module.IconTextSize100Percent,
    })),
  ),
  IconEngagement: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEngagement').then(module => ({
      default: module.IconEngagement,
    })),
  ),
  IconCircleArrowRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCircleArrowRight').then(module => ({
      default: module.IconCircleArrowRight,
    })),
  ),
  IconCircleArrowLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCircleArrowLeft').then(module => ({
      default: module.IconCircleArrowLeft,
    })),
  ),
  IconReversedArrowRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReversedArrowRight').then(module => ({
      default: module.IconReversedArrowRight,
    })),
  ),
  IconReversedArrowLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconReversedArrowLeft').then(module => ({
      default: module.IconReversedArrowLeft,
    })),
  ),
  IconDiamondArrowLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDiamondArrowLeft').then(module => ({
      default: module.IconDiamondArrowLeft,
    })),
  ),
  IconDiamondArrowRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDiamondArrowRight').then(module => ({
      default: module.IconDiamondArrowRight,
    })),
  ),
  IconTriangleArrowLeft: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTriangleArrowLeft').then(module => ({
      default: module.IconTriangleArrowLeft,
    })),
  ),
  IconTriangleArrowRight: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTriangleArrowRight').then(module => ({
      default: module.IconTriangleArrowRight,
    })),
  ),
  IconChart: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconChart').then(module => ({
      default: module.IconChart,
    })),
  ),
  IconStroke: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStroke').then(module => ({
      default: module.IconStroke,
    })),
  ),
  IconFood: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFood').then(module => ({
      default: module.IconFood,
    })),
  ),
  IconMap: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconMap').then(module => ({
      default: module.IconMap,
    })),
  ),
  IconSuitcase: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSuitcase').then(module => ({
      default: module.IconSuitcase,
    })),
  ),
  IconWellness: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconWellness').then(module => ({
      default: module.IconWellness,
    })),
  ),
  IconTextureCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextureCircleOutline').then(module => ({
      default: module.IconTextureCircleOutline,
    })),
  ),
  IconImageCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconImageCircleOutline').then(module => ({
      default: module.IconImageCircleOutline,
    })),
  ),
  IconEffectsCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEffectsCircleOutline').then(module => ({
      default: module.IconEffectsCircleOutline,
    })),
  ),
  IconStrokeCircleOutline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconStrokeCircleOutline').then(module => ({
      default: module.IconStrokeCircleOutline,
    })),
  ),
  IconCropTikTok: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCropTikTok').then(module => ({
      default: module.IconCropTikTok,
    })),
  ),
  IconColgate: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconColgate').then(module => ({
      default: module.IconColgate,
    })),
  ),
  IconCornerRadiusDotted: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCornerRadiusDotted').then(module => ({
      default: module.IconCornerRadiusDotted,
    })),
  ),
  IconShopifySquare: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifySquare').then(module => ({
      default: module.IconShopifySquare,
    })),
  ),
  IconShopifyPortrait: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifyPortrait').then(module => ({
      default: module.IconShopifyPortrait,
    })),
  ),
  IconShopifyLandscape: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifyLandscape').then(module => ({
      default: module.IconShopifyLandscape,
    })),
  ),
  IconTikTokPost: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTikTokPost').then(module => ({
      default: module.IconTikTokPost,
    })),
  ),
  IconShopee: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopee').then(module => ({
      default: module.IconShopee,
    })),
  ),
  IconPoshmark: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPoshmark').then(module => ({
      default: module.IconPoshmark,
    })),
  ),
  IconLinkedinProfile: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLinkedinProfile').then(module => ({
      default: module.IconLinkedinProfile,
    })),
  ),
  IconFBMarketplace: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconFBMarketplace').then(module => ({
      default: module.IconFBMarketplace,
    })),
  ),
  IconEtsy: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEtsy').then(module => ({
      default: module.IconEtsy,
    })),
  ),
  IconEbay: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconEbay').then(module => ({
      default: module.IconEbay,
    })),
  ),
  IconDepop: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDepop').then(module => ({
      default: module.IconDepop,
    })),
  ),
  IconAmazon: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAmazon').then(module => ({
      default: module.IconAmazon,
    })),
  ),
  IconDPI: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDPI').then(module => ({
      default: module.IconDPI,
    })),
  ),
  IconSimilarContent: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSimilarContent').then(module => ({
      default: module.IconSimilarContent,
    })),
  ),
  IconExpandTimeline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconExpandTimeline').then(module => ({
      default: module.IconExpandTimeline,
    })),
  ),
  IconCollapseTimeline: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCollapseTimeline').then(module => ({
      default: module.IconCollapseTimeline,
    })),
  ),
  IconLicense: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconLicense').then(module => ({
      default: module.IconLicense,
    })),
  ),
  IconResolutionX1: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconResolutionX1').then(module => ({
      default: module.IconResolutionX1,
    })),
  ),
  IconResolutionX2: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconResolutionX2').then(module => ({
      default: module.IconResolutionX2,
    })),
  ),
  IconResolutionX3: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconResolutionX3').then(module => ({
      default: module.IconResolutionX3,
    })),
  ),
  IconResolutionX4: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconResolutionX4').then(module => ({
      default: module.IconResolutionX4,
    })),
  ),
  IconRevert: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconRevert').then(module => ({
      default: module.IconRevert,
    })),
  ),
  IconHandle: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconHandle').then(module => ({
      default: module.IconHandle,
    })),
  ),
  IconShopifySquareLogo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifySquareLogo').then(module => ({
      default: module.IconShopifySquareLogo,
    })),
  ),
  IconShopifyPortraitLogo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifyPortraitLogo').then(module => ({
      default: module.IconShopifyPortraitLogo,
    })),
  ),
  IconShopifyLandscapeLogo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopifyLandscapeLogo').then(module => ({
      default: module.IconShopifyLandscapeLogo,
    })),
  ),
  IconShopeeLogo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconShopeeLogo').then(module => ({
      default: module.IconShopeeLogo,
    })),
  ),
  IconDepopLogo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconDepopLogo').then(module => ({
      default: module.IconDepopLogo,
    })),
  ),
  IconSwitchTextToChart: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSwitchTextToChart').then(module => ({
      default: module.IconSwitchTextToChart,
    })),
  ),
  IconCoinsPlusColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCoinsPlusColored').then(module => ({
      default: module.IconCoinsPlusColored,
    })),
  ),
  IconCoinsProColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconCoinsProColored').then(module => ({
      default: module.IconCoinsProColored,
    })),
  ),
  IconTextFree: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconTextFree').then(module => ({
      default: module.IconTextFree,
    })),
  ),
  IconAmazonLogo: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconAmazonLogo').then(module => ({
      default: module.IconAmazonLogo,
    })),
  ),
  IconSave: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconSave').then(module => ({
      default: module.IconSave,
    })),
  ),
  IconGradientColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconGradientColored').then(module => ({
      default: module.IconGradientColored,
    })),
  ),
  IconKakao: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconKakao').then(module => ({
      default: module.IconKakao,
    })),
  ),
  IconKakaoColored: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconKakaoColored').then(module => ({
      default: module.IconKakaoColored,
    })),
  ),
  IconPaymentWarning: lazy(() =>
    import('@picsart/design-system/foundation/icons/IconPaymentWarning').then(module => ({
      default: module.IconPaymentWarning,
    })),
  ),
};

export default iconsMap;
